var React = require('react');

function BarChartUp48px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M46.974 48.875h-6.975a1 1 0 0 1-.997-1.005V17.726c0-.555.447-.788.998-.788h7c.551 0 .971.233.971.788V47.87a1 1 0 0 1-.997 1.005zM41 18.939l-.005 27.927h4.982L46 18.939h-5zm3.739-7.024a.999.999 0 0 1-.921.62 1.007 1.007 0 0 1-.921-1.39l2.283-5.543L1.52 24.677a.995.995 0 0 1-.395.084.998.998 0 0 1-.916-.606 1.01 1.01 0 0 1 .518-1.322L44.184 3.847l-4.8-1.89a1.006 1.006 0 0 1-.565-1.301.994.994 0 0 1 1.292-.57l7.226 2.846c.249.098.449.294.554.542.105.249.106.53.004.779l-3.156 7.662zM1 31.939h7a1 1 0 0 1 1 1v15c0 .555-.348.936-.899.936H1.124c-.551 0-1.124-.381-1.124-.936v-15a1 1 0 0 1 1-1zm1 15h5v-13H2v13zm12-20h7a1 1 0 0 1 1 1v20c0 .555-.391.936-.941.936h-6.978c-.551 0-1.081-.381-1.081-.936v-20a1 1 0 0 1 1-1zm1 20h5v-18h-5v18zm12-25h7c.551 0 1.013.257 1.013.812V47.87a1 1 0 0 1-.997 1.005h-6.977a1 1 0 0 1-.997-1.005V22.751c0-.555.407-.812.958-.812zm1 25h5V23.938h-5v23.001z","key":1})]);
}

BarChartUp48px.displayName = "BarChartUp48px";

BarChartUp48px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 48 48.88"};

module.exports = BarChartUp48px;

BarChartUp48px.default = BarChartUp48px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/48px/bar-chart-up-48px.svg
// module id = 1127
// module chunks = 0